module.exports = __webpack_public_path__ + "img/bg-en.f677ba86.png";